import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Activity, Star } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-[#FAFAFA]" data-id="element-74">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-75">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-b from-[#E0F2FE] to-transparent opacity-60 blur-3xl" data-id="element-76" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-gradient-to-tr from-[#D1FAE5] to-transparent opacity-50 blur-3xl" data-id="element-77" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-78">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-79">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-80">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#E0F2FE] text-[#0D6E6E] font-semibold text-sm mb-8" data-id="element-81">
              <Activity className="w-4 h-4" data-id="element-82" />
              <span data-id="element-83">Método Natural Comprobado</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1A1A2E] leading-[1.1] mb-6 tracking-tight" data-id="element-84">
              Recupera el Control de tu Glucosa en{' '}
              <span className="text-[#0D6E6E] relative whitespace-nowrap" data-id="element-85">
                Solo 7 Días
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-[#D4A017]/40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-86">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" data-id="element-87" />
                </svg>
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-600 mb-10 leading-relaxed font-medium" data-id="element-88">
              El método práctico con suplementos naturales para estabilizar tu
              azúcar en sangre sin dietas imposibles.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-89">
              <CTAButton onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-90">
                ¡SÍ, QUIERO EMPEZAR MIS 7 DÍAS!
              </CTAButton>
            </div>

            <div className="mt-8 flex items-center gap-6 text-sm text-gray-500 font-medium" data-id="element-91">
              <div className="flex items-center gap-2" data-id="element-92">
                <Shield className="w-5 h-5 text-[#10B981]" data-id="element-93" />
                <span data-id="element-94">Compra 100% Segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-95">
                <div className="flex -space-x-1" data-id="element-96">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-[#D4A017] fill-[#D4A017]" data-id="element-97" />)}
                </div>
                <span data-id="element-98">Acceso Inmediato</span>
              </div>
            </div>
          </motion.div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-99">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#0D6E6E]/10 border border-white/50 bg-white p-2" data-id="element-100">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#0D6E6E]/10 to-transparent mix-blend-overlay z-10 rounded-xl" data-id="element-101" />
              <img src="https://cdn.magicpatterns.com/uploads/9qiohFSWoxYWGBS2JpmF5H/private_openrouter-generated-image-1772628955989.png" alt="Pareja feliz mostrando el Plan 7D Control en sus dispositivos" className="w-full h-auto object-cover rounded-xl relative z-0" data-id="element-102" />
            </div>

            {/* Floating Badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-gray-100 flex items-center gap-4 z-20" data-id="element-103">
              <div className="w-12 h-12 rounded-full bg-[#F0FDF4] flex items-center justify-center text-[#10B981]" data-id="element-104">
                <Activity className="w-6 h-6" data-id="element-105" />
              </div>
              <div data-id="element-106">
                <p className="text-sm font-bold text-[#1A1A2E]" data-id="element-107">
                  Resultados en
                </p>
                <p className="text-[#0D6E6E] font-extrabold text-lg" data-id="element-108">
                  1 Semana
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}